export default {
  assistant: {
    error: "J'ai rencontré un problème technique lors du traitement de votre message. Veuillez réessayer plus tard.",
    inputPlaceholder: "Tapez votre message...",
    title: "Assistant IA",
    welcome: "Bonjour ! Je suis votre assistant de voyage numérique. Je suis ici pour rendre votre voyage plus agréable en vous aidant avec vos plans et itinéraires. N’hésitez pas à m’envoyer les détails de vos voyages, je n’y ai pas encore accès. Comment puis-je vous aider aujourd’hui ? 😊"
  },
  common: {
    save: "Sauvegarder les modifications",
    cancel: "Annuler",
    saving: "Enregistrement...",
    updating: "Mise à jour...",
    back: "Retour",
    comingSoon: "Plus de fonctionnalités à venir",
    success: "Succès",
    error: "Erreur",
    deleting: "Suppression en cours...",
    toast: {
      success: "Succès",
      error: "Erreur",
      info: "Information",
      warning: "Avertissement",
      copied: "Copié dans le presse-papiers",
      saved: "Modifications enregistrées",
      deleted: "Supprimé avec succès",
      updated: "Mis à jour avec succès"
    },
    in: "à"
  },
  auth: {
    signOut: "Déconnexion",
    signOutSuccess: "Déconnexion réussie",
    redirectingHome: "Redirection vers la page d'accueil...",
    loginWithEmail: "Se connecter avec un e-mail",
    createAccount: "Créer un compte",
    welcomeBack: "Bienvenue",
    enterEmailForCode: "Entrez votre e-mail pour recevoir un code unique",
    signUpToManageTrips: "Inscrivez-vous pour commencer à gérer vos voyages",
    signInToAccessTrips: "Connectez-vous pour accéder à vos voyages",
    password: "Mot de passe",
    otpLogin: "E-mail login",
    register: "S'inscrire",
    emailConfirmationRequired: "Confirmation d'e-mail requise",
    checkEmailForConfirmation: "Veuillez vérifier votre boîte de réception pour un lien de confirmation. Vous devez confirmer votre adresse e-mail avant de continuer.",
    invalidEmail: "Veuillez entrer une adresse e-mail valide",
    confirmEmail: "Confirmer l'adresse e-mail",
    emailMismatch: "Les adresses e-mail ne correspondent pas",
    verificationEmailSent: "Veuillez vérifier vos e-mails pour trouver un code de vérification.",
    incorrectVerificationCode: "Le code de vérification est incorrect",
    loginSuccess: "Connexion réussie !",
    registrationPasswordSuccess: "Enregistrement réussi et mot de passe enregistré !",
    incorrectCredentials: "Les identifiants sont incorrects",
    otpRequestFailed: "Échec de la demande OTP",
    unexpectedError: "Une erreur inattendue s'est produite",
    codeSent: "Code envoyé",
    checkEmailForCode: "Veuillez vérifier votre e-mail pour le code de vérification.",
    sessionCreationFailed: "Échec de la création de session",
    enterVerificationCode: "Entrez le code de vérification envoyé à",
    enter6DigitCode: "Entrez le code à 6 chiffres",
    optionalPassword: "Vous pouvez éventuellement définir un mot de passe pour votre compte",
    passwordOptional: "Mot de passe (facultatif)",
    confirmPassword: "Confirmer le mot de passe",
    registrationComplete: "Inscription terminée !",
    accountCreatedRedirect: "Votre compte a été créé avec succès. Vous serez redirigé sous peu...",
    validateEmail: "Valider votre e-mail",
    passwordValidation: "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre, un caractère spécial et doit comporter entre 8 et 15 caractères.",
    signIn: "Se connecter",
    sending: "Envoi...",
    verifyEmail: "Vérifier l'e-mail",
    backToEmail: "Retour à l'e-mail",
    verifying: "Vérification...",
    validateOTP: "Valider OTP",
    noAccount: "Vous n'avez pas de compte ? Inscrivez-vous",
    travelAppLogo: "Application de voyage",
    forgotPassword: "Mot de passe oublié",
    forgotPasswordInstructions: "Veuillez vous connecter avec votre e-mail, puis changez votre mot de passe",
    firstName: "Prénom",
    lastName: "Nom de famille",
    emailAddress: "Adresse e-mail",
    confirmEmailAddress: "Confirmer l'adresse e-mail",
    termsAgreementPart1: "En créant votre compte, vous acceptez nos",
    termsOfService: "Conditions d'utilisation",
    privacyPolicy: "Politique de confidentialité",
    adtdTripPWaiting: "Votre voyage est prêt à être importé",
    adtdTripPWaitingDescription: "Veuillez vous connecter à votre compte ou en créer un pour continuer. Nous vérifierons que la réservation correspond à votre identité.",
    loginDescription: "Suivez vos vols, organisez vos voyages et accédez à toutes vos informations de voyage. Tout ce dont vous avez besoin pour un voyage sans souci, au même endroit.",
    loginAppDescription: "Toutes vos informations de voyage en un seul endroit"
  },
  settings: {
    title: "Paramètres",
    profile: {
      title: "Mon profil",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "Adresse e-mail",
      country: "Pays",
      city: "Ville",
      selectCountry: "Sélectionnez ou tapez un pays",
      enterCity: "Entrez votre ville"
    },
    language: {
      title: "Langue",
      preferred: "Langue préférée",
    },
    currency: {
      title: "Devise",
      preferred: "Devise préférée"
    },
    notifications: {
      title: "Notifications",
      emailNotifications: "Notifications par e-mail",
      description: "Recevoir des notifications par e-mail sur les mises à jour importantes",
    },
    consent: {
      title: "Gestion du consentement",
      open: "Ouvrir le gestionnaire de consentement",
      description: "Gérez vos préférences de confidentialité et de cookies"
    },
    about: {
      title: "À propos de nous",
      tos: "Conditions d'utilisation",
      privacy: "Politique de confidentialité",
      faq: "FAQ",
    },
    contact: {
      title: "Contactez-nous",
      email: "feedback@checkmytrip.com",
    },
    social: {
      title: "Retrouvez-nous sur les réseaux sociaux",
    },
    deleteAccount: "Supprimer le compte",
    deleteAccountDescription: "Supprimer définitivement votre compte et toutes les données associées",
    confirmDelete: "Êtes-vous sûr ?",
    deleteWarning: "Cette action ne peut pas être annulée. Cela supprimera définitivement votre compte et toutes vos données de nos serveurs.",
    confirmDeleteButton: "Oui, supprimer mon compte",
    accountDeleted: "Votre compte a été supprimé avec succès.",
    deleteError: "Échec de la suppression du compte",
    profileUpdated: "Profil mis à jour avec succès",
    updateError: "Erreur lors de la mise à jour du profil",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    passwordTooShort: "Le mot de passe doit comporter au moins 8 caractères",
    passwordUpdated: "Mot de passe mis à jour avec succès",
    changePassword: "Changer le mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    feedback: {
      title: "Commentaires",
      description: "Nous apprécions vos commentaires. Aidez-nous à améliorer notre service en partageant vos pensées.",
      button: "Donner un avis"
    }
  },
  index: {
    greeting: "Bonjour, voyageur",
    greetingWithName: "Bonjour, {{name}}",
    manageTrips: "Gérez vos voyages",
    bookingRef: "Référence de réservation",
    lastName: "Nom de famille",
    addTrip: "Ajouter un voyage",
    timeline: "Votre chronologie",
    welcome: {
      title: "Bienvenue dans votre application de voyage",
      ready: "Êtes-vous prêt à gérer vos voyages plus intelligemment ?",
      features: {
        tripManagement: {
          title: "Gestion de voyages",
          description: "Gardez tous vos détails de voyage en un seul endroit - vols, hôtels et activités."
        },
        tripAlerts: {
          title: "Alertes de voyage",
          description: "Recevez des notifications opportunes concernant vos vols, changements de porte et mises à jour importantes de voyage."
        },
        inspiration: {
          title: "Inspiration voyage",
          description: "Découvrez de nouvelles destinations et recevez des recommandations personnalisées pour vos aventures"
        },
        offers: {
          title: "Offres et réductions",
          description: "Accédez à des offres exclusives et économisez sur vos prochains voyages."
        }
      },
      getStarted: "Conseils rapides pour commencer",
      tips: {
        profile: "Complétez votre profil pour une expérience personnalisée",
        addTrip: "Ajoutez votre premier voyage en cliquant sur le bouton 'Nouveau voyage'",
        dates: "Suivez les dates importantes de votre voyage dans le calendrier",
        notifications: "Activez les notifications pour rester informé de vos voyages"
      }
    },
    importAdtdTripSuccess: "Voyage importé avec succès",
    importAdtdTripError: "Impossible d'importer le voyage dans ce compte",
    checkYourTrips: "Vérifiez vos voyages dans l'application"
  },
  tripCard: {
    daysLeft: "jours",
    flightDetails: "Détails du vol",
    terminal: "Terminal",
    gate: "Porte",
    checkIn: "Enregistrement",
    checkStatus: "Vérifier le statut",
    flightInfo: "Informations sur le vol",
    airline: "Compagnie aérienne",
    flight: "Vol",
    departure: "Départ",
    arrival: "Arrivée",
    getFlightDetails: "Obtenir les détails du vol",
    destinationInfo: "Informations sur la destination",
    weather: "Météo",
    activities: "Activités recommandées",
    food: "Restaurants et cafés",
    carRental: "Location de voiture",
    carModel: "Modèle de voiture",
    pickupLocation: "Lieu de prise en charge",
    dropoffLocation: "Lieu de retour",
    pickup: "Prise en charge",
    dropoff: "Retour",
    confirmationNumber: "Numéro de confirmation",
    addToCalendar: "Ajouter au calendrier",
    tripInfo: "Infos voyage",
    destination: "Destination",
    noFlightInfoFound: "Aucune information de vol trouvée",
    noFlightStatusAvailable: "Aucune information sur l'état du vol disponible",
    flightStatus: "Statut du vol",
    flightInfoUpdated: "Informations de vol mises à jour",
    failedFlightStatus: "Échec de la vérification de l'état du vol. Veuillez réessayer.",
    tripDetails: "Détails du voyage",
    deleteTrip: "Supprimer le voyage",
    confirmDelete: "Supprimer le voyage?",
    deleteWarning: "Cette action ne peut pas être annulée. Cela supprimera définitivement votre voyage à {{tripName}} et le retirera de votre compte.",
    confirmDeleteButton: "Oui, supprimer le voyage",
    tripDeleted: "Le voyage a été supprimé avec succès.",
    deleteError: "Échec de la suppression du voyage",
    cabinClass: "Classe de cabine",
    bookingReference: "Référence de réservation",
    confirmationNumbers: "Numéros de confirmation",
    notifications: "Notifications",
    notificationsDescription: "Notifications importantes concernant vos voyages",
    noNotifications: "Aucune notification pour le moment",
    notificationsOnMobile: "Cette fonctionnalité n'est disponible que sur l'application mobile pour le moment",
    taxiTransfer: "Réserver une course",
    taxiTransferDesc: "Réserver un transfert en taxi vers votre hôtel ou l'aéroport",
    taxiTransferComingSoon: "Transfert en taxi bientôt disponible",
    economy: "Économique",
    loadingNotifications: "Chargement des notifications..."
  },
  newTrip: {
    title: "Ajouter un nouveau voyage",
    bookingReference: "Référence de réservation",
    bookingReferenceDesc: "Entrez votre référence de réservation de 6 caractères et assurez-vous que le prénom et le nom de votre profil sont les mêmes que dans votre réservation.",
    bookingRefPlaceholder: "Référence (ex: ABC123)",
    bookingRefTooShort: "La référence de réservation doit comporter au moins 6 caractères",
    bookingRefTooLong: "La référence de réservation ne peut pas dépasser 10 caractères",
    lastNamePlaceholder: "Nom de famille",
    findBooking: "Trouver la réservation",
    gmailSync: "Synchroniser avec Gmail",
    gmailSyncDesc: "Permettez-nous de scanner votre boîte de réception Gmail pour rechercher des réservations de voyage",
    connectGmail: "Connecter un compte Gmail",
    emailForward: "Transférer l'e-mail de réservation",
    emailForwardDesc: "Transférez votre e-mail de confirmation de réservation pour ajouter votre voyage",
    emailCopied: "Adresse e-mail copiée",
    emailCopiedDesc: "L'adresse e-mail a été copiée dans le presse-papiers",
    copyEmail: "Copier l'adresse e-mail",
    manual: "Saisie manuelle",
    manualDesc: "Ajoutez manuellement les détails de votre voyage",
    startManual: "Démarrer la saisie manuelle",
    bookingSubmitted: "Réservation soumise",
    processingBooking: "Nous recherchons votre réservation...",
    gmailConsent: "Connexion Gmail",
    gmailProcessing: "Connexion à votre compte Gmail...",
    manualEntry: "Saisie manuelle du voyage",
    manualEntryDesc: "Créez un voyage en ajoutant vous-même les détails des vols et des hôtels",
    drawer: {
      addTripDetails: "Ajouter les détails du voyage",
      tripInfo: "Informations sur le voyage",
      tripName: "Nom du voyage",
      tripType: "Type de voyage",
      selectTripType: "Sélectionner le type de voyage",
      leisure: "Loisirs",
      business: "Affaires",
      family: "Famille",
      bleisure: "Loisirs et affaires",
      travelers: "Nombre de voyageurs",
      addFlight: "Ajouter un vol",
      flightNumber: "Numéro de vol (ex. IB1234)",
      departureDate: "Date de départ",
      addedFlights: "Vols ajoutés",
      from: "De :",
      to: "À :",
      terminal: "Terminal :",
      departure: "Départ :",
      arrival: "Arrivée :",
      addHotel: "Ajouter un hôtel",
      hotelName: "Nom de l'hôtel",
      cityName: "Nom de la ville",
      selectCheckInOut: "Sélectionner les dates d'arrivée/départ",
      addedHotels: "Hôtels ajoutés",
      createTrip: "Créer un voyage",
      adding: "Ajout en cours...",
      selectFlight: "sélectionner un vol",
      confirmFlight: "Confirmer le vol",
      step1: "Infos",
      step2: "Vols",
      step3: "Hôtels",
      step4: "Révision",
      next: "Suivant",
      back: "Retour",
      review: "Vérifier",
      flightsStepEmpty: "Ajoutez au moins un vol à votre voyage",
      flightsStepWithFlights: "Vous avez ajouté {{count}} vol(s)",
      hotelsStepEmpty: "Ajoutez des hôtels à votre voyage (facultatif)",
      hotelsStepWithHotels: "Vous avez ajouté {{count}} hôtel(s)",
      reviewTrip: "Vérifiez votre voyage",
      reviewDescription: "Vérifiez les détails de votre voyage avant de le créer",
      tripSummary: "Résumé du voyage",
      flightsSummary: "Vols",
      hotelsSummary: "Hôtels",
    },
    profileMismatch: "Désolé, les informations de votre profil ne correspondent pas à la réservation. Veuillez vous rendre dans votre Profil et vous assurer que vos prénom et nom sont les mêmes que ceux utilisés pour la réservation. Vous pouvez également essayer d'importer votre voyage avec les options suivantes ci-dessous en transférant votre e-mail de confirmation de réservation ou en saisissant le voyage manuellement."
  },
  discover: {
    title: "Découvrir des expériences",
    subtitle: "Trouvez et explorez des activités pour votre prochaine aventure",
    getInspired: "Inspirez-vous",
    searchFilters: "Filtres de recherche",
    search: "Rechercher",
    city: "Ville",
    enterCityName: "Entrez le nom de la ville",
    priceRange: "Fourchette de prix",
    min: "Min",
    max: "Max",
    radius: "Rayon (km)",
    enterRadius: "Entrez le rayon",
    searchButton: "Rechercher",
    categoryTypes: "Catégories",
    popularActivities: "Activités populaires",
    searchPlaceholder: "Rechercher des activités, lieux ou expériences...",
    allActivities: "Toutes les activités",
    inspiration: {
      location: "Emplacement",
      price: "Fourchette de prix",
      bestTimeToVisit: "Meilleur moment pour visiter",
      howToGetThere: "Comment s'y rendre"
    },
    categories: {
      tour: "Visite",
      adventure: "Aventure",
      food: "Gastronomie",
      culture: "Culture",
      sightseeing: "Tourisme",
      entertainment: "Divertissement",
      nature: "Nature",
      wellness: "Bien-être",
      sport: "Sport",
      workshop: "Atelier"
    }
  },
  sidebar: {
    assistant: "Assistant",
    myTrips: "Mes voyages",
    discover: "Découvrir",
    newTrip: "Nouveau voyage",
    profile: "Profil"
  },
  weather: {
    in: "Météo à",
    loading: "Chargement des données météo...",
    currentWeather: "Météo actuelle",
    forecast: "Prévisions",
    temperature: "Température",
    feelsLike: "Ressenti",
    wind: "Vent",
    humidity: "Humidité",
    precipitation: "Précipitations",
    pressure: "Pression",
    visibility: "Visibilité",
    uvIndex: "Indice UV",
    sunrise: "Lever du soleil",
    sunset: "Coucher du soleil",
    daily: "Quotidien",
    hourly: "Horaire",
    today: "Aujourd'hui",
    tomorrow: "Demain",
    min: "Min",
    max: "Max"
  }
}
